<template>
  <a-layout id="components-layout-demo-top-side-2" style="overflow-y: hidden">
    <a-layout-header
      class="header"
      style="background: #00479c; border: 1px solid #000000; padding-left: 10px"
    >
      <div>
        <div style="float: right; width: 220px; margin-right: 20px">
          <div style="float: left; width: 140px">
            <!-- <div style="float:left;margin-right:10px;">
                <img :src="photo" style="width:40px;border-radius: 50px;" />
              </div> -->
            <div>
              <a-dropdown>
                <a
                  style="color: #ffffff; float: right; margin-right: 20px"
                  class="ant-dropdown-link"
                >
                  {{ userName }}
                  <a-icon type="down " />
                </a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a-button
                      href="javascript:;"
                      @click="showModal"
                      style="display: block; margin: 0; border: none"
                    >
                      用户信息
                    </a-button>
                    <a-modal
                      title="用户信息"
                      :visible="visible"
                      okText="保存"
                      @ok="handleOk"
                      :confirmLoading="confirmLoading"
                      @cancel="handleCancel"
                      centered
                      :maskClosable="false"
                    >
                      <p>
                        <span style="color: red; margin-left: 30px">*</span>
                        <span>作者姓名：</span>
                        <a-input
                          placeholder="请输入"
                          style="width: 200px"
                          v-model="person.authorName"
                        />
                      </p>
                      <p>
                        <label style="margin-left: 63px">性别：</label>
                        <a-radio-group @change="sexChange" v-model="value">
                          <a-radio :value="1">男</a-radio>
                          <a-radio :value="0">女</a-radio>
                        </a-radio-group>
                      </p>
                      <p>
                        <span style="margin-left: 35px">出生年月：</span>
                        <a-month-picker :value="date" @change="dateChange" />
                      </p>
                      <p>
                        <span style="margin-left: 63px">职称：</span>
                        <a-input
                          placeholder="请输入"
                          style="width: 200px"
                          v-model="person.professionalTitle"
                        />
                      </p>
                      <p>
                        <span style="margin-left: 35px">研究方向：</span>
                        <a-input
                          placeholder="请输入"
                          style="width: 200px"
                          v-model="person.studyDirection"
                        />
                      </p>
                      <!-- <p>
                          <label style="margin-left:63px;">学历：</label>
                          <a-select
                            defaultValue="0"
                            style="width:200px;"
                            @change="handleChange"
                            v-model="person.eduLevel"
                          >
                            <a-select-option value="0">请选择</a-select-option>
                            <a-select-option value="1">博士</a-select-option>
                            <a-select-option value="2">硕士</a-select-option>
                            <a-select-option value="3">本科</a-select-option>
                            <a-select-option value="4">其他</a-select-option>
                          </a-select>
                        </p> -->
                      <p>
                        <span style="color: red; margin-left: 30px">*</span>
                        <span>所在省市：</span>
                        <a-select
                          v-model="person.province"
                          style="width: 180px"
                          @change="handleProvinceChange"
                          placeholder="请选择"
                        >
                          <a-select-option
                            v-for="val in provinces"
                            :value="val.name"
                            :key="val.name"
                          >
                            {{ val.name }}
                          </a-select-option>
                        </a-select>
                        <a-select
                          v-model="person.city"
                          style="width: 180px"
                          placeholder="请选择"
                          @change="onCityChange"
                        >
                          <a-select-option
                            v-for="item in cities"
                            :value="item.name"
                            :key="item.name"
                          >
                            {{ item.name }}
                          </a-select-option>
                        </a-select>
                      </p>
                      <p>
                        <span style="color: red; margin-left: 30px">*</span>
                        <span>邮政编码：</span>
                        <a-input
                          placeholder="请输入"
                          class="input"
                          style="width: 200px"
                          v-model="person.postCode"
                        />
                      </p>
                      <p>
                        <span style="color: red; margin-left: 30px">*</span>
                        <label>单位名称：</label>
                        <a-input
                          placeholder="请输入"
                          style="width: 200px"
                          v-model="person.companyName"
                        />
                      </p>
                      <p>
                        <span style="color: red; margin-left: 30px">*</span>
                        <label>单位地址：</label>
                        <a-input
                          placeholder="请输入"
                          style="width: 200px"
                          v-model="person.companyAddress"
                        />
                      </p>
                      <div>
                        <span style="color: red; margin-left: 30px">*</span>
                        <label>联系电话：</label>
                        <a-input
                          placeholder="请输入"
                          style="width: 200px"
                          v-model="person.phone"
                        />
                        <p
                          style="
                            color: #ff0000;
                            font-size: 12px;
                            margin-left: 100px;
                          "
                        >
                          *该联系电话将作为接收收稿、采用等通知的手机号
                        </p>
                      </div>
                      <div>
                        <span style="color: red; margin-left: 49px">*</span>
                        <label>E-mail：</label>
                        <a-input
                          placeholder="请输入"
                          style="width: 200px"
                          v-model="person.email"
                        />
                        <p
                          style="
                            color: #ff0000;
                            font-size: 12px;
                            margin-left: 100px;
                          "
                        >
                          *该联系电话将作为接收收稿、采用等通知的手机号
                        </p>
                      </div>
                    </a-modal>
                  </a-menu-item>

                  <a-menu-item>
                    <a-button
                      href="javascript:;"
                      @click="showBox"
                      style="display: block; margin: 0; border: none"
                    >
                      修改密码
                    </a-button>
                  </a-menu-item>
                  <a-menu-item>
                    <SysVersion />
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
          </div>

          <div style="float: right; width: 80px">
            <div style="float: left">
              <a-badge :count="informCount" @click="showInform">
                <img
                  src="..\..\assets\notice.png"
                  style="width: 20px; height: 20px; cursor: pointer"
                />
                <a href="#" class="head-example"></a>
              </a-badge>
            </div>
            <div style="float: right">
              <a-badge style="margin-left: 20px">
                <a @click="exit" style="color: #ffffff">退出</a>
              </a-badge>
            </div>
          </div>
        </div>

        <a-modal
          title="修改密码"
          :visible="visibles"
          centered
          :maskClosable="false"
          :destroyOnClose="true"
          :closable="!changePwd"
        >
        <template slot="footer">
          <a-button key="back" @click="handleCancels" v-if="!changePwd">
            取消
          </a-button>
          <a-button key="submit" type="primary" :loading="confirmLoadings" @click="handleOks">
            保存
          </a-button>
        </template>
          <!-- <img
              :src="newPhoto"
              style="width: 90px; height: 90px; margin: 0 40%"
            /> -->
          <!-- <p style="color: #1abc9c; text-align: center">
              <a-upload
                name="file"
                :fileList="fileList"
                :action="uploadAddress"
                :headers="headers"
                @change="uploadFile"
                :remove="fileRemove"
                :data="data"
                accept=".png, .jpg"
              >
                <a-button>
                  <a-icon type="upload" />选择图片
                </a-button>
              </a-upload>
            </p> -->
          <p style="text-align: center; margin-top: 30px">
            <span style="margin-left: 21px">用户名：</span>
            <a-input
              placeholder="请输入"
              style="width: 200px"
              v-model="zhanghao"
              read-only
            />
          </p>
          <p style="text-align: center">
            <span style="color: red; margin-left: 15px">*</span>
            <span>旧密码：</span>
            <a-input
              placeholder="请输入"
              style="width: 200px"
              v-model="oldPwd"
            />
          </p>
          <p style="text-align: center">
            <span style="color: red; margin-left: 15px">*</span>
            <span>新密码：</span>
            <a-input
              placeholder="请输入"
              style="width: 200px"
              v-model="newPwd"
            />
            <span class="note" style="display: block;"> 密码8至16位，包含大小写字母、数字和特殊字符 </span>
          </p>
          <p style="text-align: center">
            <span style="color: red">*</span>
            <span>确认密码：</span>
            <a-input
              placeholder="请输入"
              style="width: 200px"
              v-model="confirmNew"
            />
          </p>
        </a-modal>

        <a-modal
          title="消息"
          :visible="informVisible"
          width="800px"
          :dialog-style="{ top: '30px' }"
          @cancel="informCancel"
          :destroyOnClose="true"
          :footer="null"
          :maskClosable="false"
        >
          <a-list
            item-layout="horizontal"
            :data-source="informData"
            style="padding-left: 12px; padding-right: 12px"
          >
            <a-list-item slot="renderItem" slot-scope="item, index">
              <a-list-item-meta>
                <a
                  slot="title"
                  href="javascript:;"
                  @click="dealInform(item.type, item.informCode)"
                  >{{ `${index + 1}、${item.content}` }}</a
                >
                <span
                  style="display: inline-block; text-align: right; width: 100%"
                  slot="description"
                  >{{ item.creatTime }}</span
                >
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-modal>
      </div>
      <!-- <div class="logo" style="width: 50px; height: 50px; float: left">
          <img
            :src="logo"
            style="width: 40px; height: 40px; margin-bottom: 8px"
          />
        </div> -->
      <div
        style="
          height: 64px;
          width: 190px;
          line-height: 64px;
          float: left;
          text-align: center;
        "
      >
        <span
          style="
            color: #ffffff;
            font-size: 18px;
            font-family: '黑体 Bold', '黑体 Regular', '黑体';
          "
          >{{ authorSystemName }}</span
        >
      </div>
    </a-layout-header>

    <a-layout>
      <a-layout-sider :trigger="null" collapsible style="background: #eaedf1">
        <a-menu
          style="background: #eaedf1"
          mode="inline"
          @click="handleClick"
          :selectedKeys="[selectedKeys]"
          :defaultOpenKeys="['01', '10', '11']"
        >
          <template v-for="menu in menus">
            <a-menu-item :key="menu.menuCode" v-if="menu.child == null">
              <router-link :to="menu.url">
                <span>{{ menu.menuName }}</span>
              </router-link>
            </a-menu-item>
            <a-sub-menu :key="menu.menuCode" v-if="menu.child != null">
              <span slot="title">
                <span>{{ menu.menuName }}</span>
              </span>
              <a-menu-item :key="m.menuCode" v-for="m in menu.child">
                <router-link :to="m.url">
                  <span>{{ m.menuName }}</span>
                </router-link>
              </a-menu-item>
            </a-sub-menu>
          </template>
        </a-menu>
      </a-layout-sider>

      <a-layout>
        <a-breadcrumb style="height: 32px; line-height: 32px; padding: 0 12px">
          <a-breadcrumb-item>{{ currentMenu }}</a-breadcrumb-item>
        </a-breadcrumb>
        <a-layout-content
          :style="{
            padding: '8px',
            height: 'calc(100vh - 96px)',
          }"
        >
          <router-view v-if="isRouterAlive"></router-view>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import qs from "qs";
import moment from "moment";
import cityData from "../../assets/js/city.js";
import SysVersion from "../commomon/SysVersion.vue";
export default {
  name: "app",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      locale: zhCN,
      menus: [],
      currentMenu: "",
      selectedKeys: "01",
      userName: "",
      informVisible: false,
      informCount: 0,
      informData: [],
      value: 1,
      visible: false,
      visibles: false,
      confirmLoading: false,
      confirmLoadings: false,
      person: {},
      photo: "",
      newPhoto: "",
      date: null,
      phone: "",
      oldPhone: "",
      zhanghao: "",
      oldPwd: "",
      newPwd: "",
      confirmNew: "",
      serviceAddress: this.$config.serviceAddress,
      uploadAddress: this.$config.serviceAddress + "/file/uploadHeadPortrait",
      headers: {
        authorization: "authorization-text",
      },
      data: {
        fileType: "headPortrait",
      },
      fileList: [],
      isRouterAlive: true,
      authorSystemName: "",
      logo: "",
      provinces: cityData,
      cities: [],
      changePwd: false,
    };
  },
  components: {
    SysVersion: SysVersion,
  },
  created() {
    document.onkeydown = function () {};
    this.getCurrent();
    this.queryLogo();

    var selectedKeys = sessionStorage.getItem("selectedKeys");
    if (selectedKeys != null) {
      this.selectedKeys = selectedKeys;
    } else {
      this.selectedKeys = "1002";
    }
    var currentMenu = sessionStorage.getItem("currentMenu");
    if (currentMenu != null) {
      this.currentMenu = currentMenu;
    } else {
      this.currentMenu = "稿件管理>>我的稿件";
    }
  },
  mounted() {
    this.changePwd = sessionStorage.getItem("needChangePwd") == "true";
    if (this.changePwd) {
      this.$message.warning("检测到您密码强度低，请修改密码后才能登录系统");
      this.showBox();
    }
  },
  methods: {
    handleProvinceChange(value) {
      this.cities = cityData.find((item) => item.name == value).children;
      this.person.city = this.cities[0].name;
    },
    onCityChange(val) {
      this.person.city = val;
      this.$forceUpdate();
    },
    handleClick(e) {
      var menuPath = e.keyPath;
      this.selectedKeys = menuPath[0];
      sessionStorage.setItem("selectedKeys", this.selectedKeys);
      if (menuPath.length == 2) {
        for (var i = 0; i < this.menus.length; i++) {
          if (menuPath[1] == this.menus[i].menuCode) {
            for (var j = 0; j < this.menus[i].child.length; j++) {
              if (menuPath[0] == this.menus[i].child[j].menuCode) {
                this.currentMenu =
                  this.menus[i].menuName +
                  ">>" +
                  this.menus[i].child[j].menuName;
                sessionStorage.setItem("currentMenu", this.currentMenu);
              }
            }
          }
        }
      } else if (menuPath.length == 1) {
        for (var ii = 0; ii < this.menus.length; ii++) {
          if (menuPath[0] == this.menus[ii].menuCode) {
            this.currentMenu = this.menus[ii].menuName;
            sessionStorage.setItem("currentMenu", this.menus[ii].menuName);
          }
        }
      }

      //刷新页面
      this.reload();
    },
    queryLogo() {
      this.axios
        .get("/basicInfo/queryBasicInfo", {
          params: {
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.authorSystemName = res.data.data.authorSystemName;
            this.logo = this.serviceAddress + res.data.data.logoPath;
          } else {
            this.utils.messageInfo(this, "error", "查询系统基本信息失败！");
          }
        });
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    uploadFile(info) {
      this.fileList = [];
      if (info.fileList.length == 2) {
        info.fileList.splice(0, 1);
      }
      let fileList = [...info.fileList];
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });
      this.fileList = fileList;
      if (info.file.status !== "uploading") {
        this.fileList = info.fileList;
        if (this.fileList[0].response.code == "OK") {
          this.newPhoto =
            this.serviceAddress + this.fileList[0].response.data.filePath;
        }
      }
      if (info.file.status === "done") {
        this.utils.messageInfo(this, "success", "上传成功");
      } else if (info.file.status === "error") {
        this.utils.messageInfo(this, "error", "上传失败");
      }
    },
    fileRemove() {
      this.fileList = [];
    },
    dateChange(date, dateString) {
      this.date = date;
      this.person.birth = dateString;
    },
    dealInform(type, informCode) {
      this.informVisible = false;
      if (type == 11) {
        //跳转到我的稿件菜单
        this.informUpdate(type, informCode, "/author/myManuscript", 10, 1002);
      }
    },
    //设置消息状态为已读
    informUpdate(type, informCode, router, defaultSiderSelectedKey) {
      this.axios
        .post("/inform/updateInform", {
          informCode: informCode,
          userCode: sessionStorage.getItem("userCode"),
          status: 1,
          type: type,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.$router.push(router);
            this.defaultSiderSelectedKey = defaultSiderSelectedKey;
            this.queryInformCount();
          }
        });
    },
    getCurrent() {
      this.axios
        .get("/systemUser/getCurrent", {
          params: {
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            var systemUser = res.data.data.systemUser;
            this.userName = systemUser.name;
            this.menus = res.data.data.menus;
            this.informCount = res.data.data.informCount;
          } else {
            this.exit();
          }
        });
    },
    queryInformCount() {
      this.axios
        .get("/inform/queryInformCount", {
          params: {
            userCode: sessionStorage.getItem("userCode"),
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          this.informCount = res.data;
        });
    },
    showInform() {
      this.informVisible = true;
      this.axios
        .get("/inform/queryInform", {
          params: {
            userCode: sessionStorage.getItem("userCode"),
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          this.informData = res.data;
        });
    },
    informCancel() {
      this.informVisible = false;
    },
    exit() {
      this.$router.push("/authorLogin");
      this.axios.get("/systemUser/logout");
    },
    showModal() {
      this.axios
        .get("/author/queryAuthorInfo", {
          params: {
            userCode: sessionStorage.getItem("userCode"),
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.person = res.data.data;
            this.oldPhone = this.person.phone;
            this.value = this.person.sex;
            this.date = null;
            var birth = this.person.birth;
            if (birth != undefined && birth != "") {
              this.date = moment(birth, "YYYY-MM");
            }
            this.visible = true;
          } else {
            this.utils.messageInfo(this, "error", "查询失败！");
          }
        });
    },
    handleOk() {
      if (this.person.authorName == "") {
        this.utils.messageInfo(this, "error", "作者姓名不能为空！");
        return;
      } else if (this.person.phone == "") {
        this.utils.messageInfo(this, "error", "联系电话不能为空！");
        return;
      } else if (this.person.email == "") {
        this.utils.messageInfo(this, "error", "E-mail不能为空！");
        return;
      } else if (this.person.companyName == "") {
        this.utils.messageInfo(this, "error", "单位名称不能为空！");
        return;
      } else if (this.person.province == "" || this.person.city == "") {
        this.utils.messageInfo(this, "error", "所在省市不能为空！");
        return;
      } else if (this.person.postCode == "") {
        this.utils.messageInfo(this, "error", "邮政编码不能为空！");
        return;
      } else if (this.person.companyAddress == "") {
        this.utils.messageInfo(this, "error", "单位地址不能为空！");
        return;
      }
      if (!this.utils.isPhone(this.person.phone)) {
        this.utils.messageInfo(this, "error", "手机号格式不正确！");
        return;
      }
      if (!this.utils.isEmail(this.person.email)) {
        this.utils.messageInfo(this, "error", "邮箱格式不正确！");
        return;
      }
      this.axios
        .post("/author/updateAuthor", {
          authorCode: this.person.authorCode,
          authorName: this.person.authorName,
          phone: this.person.phone,
          email: this.person.email,
          companyName: this.person.companyName,
          companyAddress: this.person.companyAddress,
          professionalTitle: this.person.professionalTitle,
          studyDirection: this.person.studyDirection,
          province: this.person.province,
          city: this.person.city,
          postCode: this.person.postCode,
          sex: this.person.sex,
          birth: this.person.birth,
          eduLevel: this.person.eduLevel,
          status: this.person.status,
          oldPhone: this.oldPhone,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "修改成功");
            this.visible = false;
            this.userName = this.person.authorName;
          } else {
            this.utils.messageInfo(this, "error", res.data.data);
          }
        });
      // this.confirmLoading = true;
      // setTimeout(() => {
      //   this.visible = false;
      //   this.confirmLoading = false;
      // }, 2000);
    },
    handleChange() {},
    handleCancel() {
      this.visible = false;
    },
    sexChange(e) {
      this.person.sex = e.target.value;
    },
    showBox() {
      this.zhanghao = "";
      this.oldPwd = "";
      this.newPwd = "";
      this.confirmNew = "";
      this.newPhoto = this.photo;

      this.axios
        .get("/author/queryAuthorInfo", {
          params: {
            userCode: sessionStorage.getItem("userCode"),
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.phone = res.data.data.phone;
            this.zhanghao = res.data.data.phone;
            this.visibles = true;
          } else {
            this.utils.messageInfo(this, "error", "查询用户名失败！");
          }
        });
    },
    handleOks() {
      if (this.zhanghao != this.phone) {
        this.utils.messageInfo(this, "error", "请输入正确用户名！");
        return;
      }
      if (this.oldPwd == "") {
        this.utils.messageInfo(this, "error", "请输入旧密码！");
        return;
      } else if (this.newPwd == "") {
        this.utils.messageInfo(this, "error", "请输入新密码！");
        return;
      }
      if (!this.utils.checkPwd(this.newPwd)) {
        this.utils.messageInfo(this, "error", "密码必须是8至16位，包含大小写字母、数字和特殊字符");
        return;
      }
      if (this.newPwd != this.confirmNew) {
        this.utils.messageInfo(this, "error", "新密码和确认密码不一致！");
        return;
      }

      var imgPath = "";
      if (this.fileList.length > 0) {
        if (this.fileList[0].response.code == "OK") {
          imgPath = this.fileList[0].response.data.filePath;
        }
      }

      this.axios
        .post("/systemUser/updatePwd", {
          userCode: sessionStorage.getItem("userCode"),
          oldPwd: this.oldPwd,
          newPwd: this.newPwd,
          imgPath: imgPath,
          time: new Date().getTime(),
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "修改成功,请重新登录");
            this.exit();
          } else {
            this.utils.messageInfo(this, "error", res.data.data);
          }
        });
      // this.confirmLoadings = true;
      // setTimeout(() => {
      //   this.visibles = false;
      //   this.confirmLoadings = false;
      // }, 2000);
    },
    handleCancels() {
      this.visibles = false;
    },
  },
};
</script>

<style scoped>
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

/* #components-layout-demo-custom-trigger .logo {
  width: 120px;
  height: 64px;
  margin: 0 18px 16px 0;
  float: left;
} */
.head-example {
  border-radius: 2px;
  background: #eee;
  display: inline-block;
}
#root {
  width: 100%;
  font-size: 15px;
}
</style>
